module.exports = __webpack_public_path__ + "static/media/ilustrasi-perangkat.c39d3ec5.png";